/**
 * Download page translations for en, es, hi, pt, id
 */
export default {
  en: {
    title: '<strong>GBWhatsApp</strong> APK Download - Latest Version 2026',
    headerDesc: 'Download <strong>GBWhatsApp APK</strong> with anti-ban protection. Get the latest v18.80 with enhanced privacy, custom themes, and exclusive features.',
    downloadBtn: 'Download GBWhatsApp APK (85MB)',
    versionNote: 'Latest Version: v18.80 | Updated: March 2026',
    appInfoTitle: 'App Information',
    appName: 'App Name:',
    version: 'Version:',
    fileSize: 'File Size:',
    releaseDate: 'Release Date:',
    androidReq: 'Android Required:',
    developer: 'Developer:',
    price: 'Price:',
    license: 'License:',
    march2026: 'March 2026',
    free: 'Free',
    freeware: 'Freeware',
    modsTitle: 'Other WhatsApp MODs Available',
    modsIntro: 'We also provide downloads for other popular WhatsApp modifications:',
    featuresTitle: "What's New in GBWhatsApp v18.80",
    installTitle: 'How to Download and Install GBWhatsApp',
    requirementsTitle: 'System Requirements',
    faqTitle: 'Frequently Asked Questions',
    faq1Q: 'Is GBWhatsApp safe to download?',
    faq1A: 'Yes, GBWhatsApp is safe when downloaded from trusted sources. Our downloads are verified and include anti-ban protection.',
    faq2Q: 'Will I lose my chats if I switch to GBWhatsApp?',
    faq2A: 'No, you can backup your chats in WhatsApp and restore them in GBWhatsApp during setup.',
    faq3Q: 'Can I use GBWhatsApp with my current WhatsApp account?',
    faq3A: 'No, you need a different phone number for GBWhatsApp. You can use both apps simultaneously.',
  },
  es: {
    title: 'Descargar GBWhatsApp APK - Última Versión 2026',
    headerDesc: 'Descarga GBWhatsApp APK con protección anti-baneo. Obtén la v18.80 con mayor privacidad, temas personalizados y funciones exclusivas.',
    downloadBtn: 'Descargar GBWhatsApp APK (85MB)',
    versionNote: 'Última versión: v18.80 | Actualizado: Marzo 2026',
    appInfoTitle: 'Información de la aplicación',
    appName: 'Nombre:',
    version: 'Versión:',
    fileSize: 'Tamaño:',
    releaseDate: 'Fecha de lanzamiento:',
    androidReq: 'Android requerido:',
    developer: 'Desarrollador:',
    price: 'Precio:',
    license: 'Licencia:',
    march2026: 'Marzo 2026',
    free: 'Gratis',
    freeware: 'Freeware',
    modsTitle: 'Otros MODs de WhatsApp disponibles',
    modsIntro: 'También ofrecemos descargas de otras modificaciones populares de WhatsApp:',
    featuresTitle: 'Novedades de GBWhatsApp v18.80',
    installTitle: 'Cómo descargar e instalar GBWhatsApp',
    requirementsTitle: 'Requisitos del sistema',
    faqTitle: 'Preguntas frecuentes',
    faq1Q: '¿Es seguro descargar GBWhatsApp?',
    faq1A: 'Sí, GBWhatsApp es seguro cuando se descarga de fuentes confiables. Nuestras descargas están verificadas e incluyen protección anti-baneo.',
    faq2Q: '¿Perderé mis chats si cambio a GBWhatsApp?',
    faq2A: 'No, puedes hacer una copia de seguridad en WhatsApp y restaurarla en GBWhatsApp durante la configuración.',
    faq3Q: '¿Puedo usar GBWhatsApp con mi cuenta actual de WhatsApp?',
    faq3A: 'No, necesitas un número de teléfono diferente para GBWhatsApp. Puedes usar ambas aplicaciones a la vez.',
  },
  hi: {
    title: 'GBWhatsApp APK डाउनलोड - नवीनतम संस्करण 2026',
    headerDesc: 'एंटी-बैन सुरक्षा के साथ GBWhatsApp APK डाउनलोड करें। बेहतर प्राइवेसी, कस्टम थीम और विशेष फीचर्स के साथ v18.80 पाएं।',
    downloadBtn: 'GBWhatsApp APK डाउनलोड करें (85MB)',
    versionNote: 'नवीनतम संस्करण: v18.80 | अपडेट: मार्च 2026',
    appInfoTitle: 'ऐप जानकारी',
    appName: 'ऐप का नाम:',
    version: 'संस्करण:',
    fileSize: 'फाइल आकार:',
    releaseDate: 'रिलीज़ तारीख:',
    androidReq: 'Android आवश्यक:',
    developer: 'डेवलपर:',
    price: 'कीमत:',
    license: 'लाइसेंस:',
    march2026: 'मार्च 2026',
    free: 'मुफ्त',
    freeware: 'फ्रीवेयर',
    modsTitle: 'अन्य WhatsApp MODs उपलब्ध',
    modsIntro: 'हम अन्य लोकप्रिय WhatsApp मॉडिफिकेशन के डाउनलोड भी प्रदान करते हैं:',
    featuresTitle: 'GBWhatsApp v18.80 में क्या नया है',
    installTitle: 'GBWhatsApp कैसे डाउनलोड और इंस्टॉल करें',
    requirementsTitle: 'सिस्टम आवश्यकताएं',
    faqTitle: 'अक्सर पूछे जाने वाले प्रश्न',
    faq1Q: 'क्या GBWhatsApp डाउनलोड करना सुरक्षित है?',
    faq1A: 'हां, विश्वसनीय स्रोतों से डाउनलोड करने पर GBWhatsApp सुरक्षित है। हमारे डाउनलोड सत्यापित हैं और एंटी-बैन सुरक्षा शामिल है।',
    faq2Q: 'क्या GBWhatsApp पर स्विच करने से मेरी चैट्स खत्म हो जाएंगी?',
    faq2A: 'नहीं, आप WhatsApp में बैकअप ले सकते हैं और सेटअप के दौरान GBWhatsApp में रिस्टोर कर सकते हैं।',
    faq3Q: 'क्या मैं अपने मौजूदा WhatsApp अकाउंट के साथ GBWhatsApp इस्तेमाल कर सकता हूं?',
    faq3A: 'नहीं, GBWhatsApp के लिए आपको अलग नंबर चाहिए। आप दोनों ऐप एक साथ इस्तेमाल कर सकते हैं।',
  },
  pt: {
    title: 'Baixar GBWhatsApp APK - Última Versão 2026',
    headerDesc: 'Baixe o GBWhatsApp APK com proteção anti-ban. Obtenha a v18.80 com privacidade aprimorada, temas personalizados e recursos exclusivos.',
    downloadBtn: 'Baixar GBWhatsApp APK (85MB)',
    versionNote: 'Última versão: v18.80 | Atualizado: Março 2026',
    appInfoTitle: 'Informações do aplicativo',
    appName: 'Nome:',
    version: 'Versão:',
    fileSize: 'Tamanho:',
    releaseDate: 'Data de lançamento:',
    androidReq: 'Android necessário:',
    developer: 'Desenvolvedor:',
    price: 'Preço:',
    license: 'Licença:',
    march2026: 'Março 2026',
    free: 'Grátis',
    freeware: 'Freeware',
    modsTitle: 'Outros MODs do WhatsApp disponíveis',
    modsIntro: 'Também oferecemos downloads de outras modificações populares do WhatsApp:',
    featuresTitle: 'Novidades do GBWhatsApp v18.80',
    installTitle: 'Como baixar e instalar o GBWhatsApp',
    requirementsTitle: 'Requisitos do sistema',
    faqTitle: 'Perguntas frequentes',
    faq1Q: 'O GBWhatsApp é seguro para baixar?',
    faq1A: 'Sim, o GBWhatsApp é seguro quando baixado de fontes confiáveis. Nossos downloads são verificados e incluem proteção anti-ban.',
    faq2Q: 'Vou perder meus chats se mudar para o GBWhatsApp?',
    faq2A: 'Não, você pode fazer backup no WhatsApp e restaurar no GBWhatsApp durante a configuração.',
    faq3Q: 'Posso usar o GBWhatsApp com minha conta atual do WhatsApp?',
    faq3A: 'Não, você precisa de um número de telefone diferente para o GBWhatsApp. Você pode usar os dois aplicativos ao mesmo tempo.',
  },
  id: {
    title: 'Download GBWhatsApp APK - Versi Terbaru 2026',
    headerDesc: 'Unduh GBWhatsApp APK dengan perlindungan anti-ban. Dapatkan v18.80 dengan privasi yang ditingkatkan, tema kustom, dan fitur eksklusif.',
    downloadBtn: 'Unduh GBWhatsApp APK (85MB)',
    versionNote: 'Versi terbaru: v18.80 | Diperbarui: Maret 2026',
    appInfoTitle: 'Informasi Aplikasi',
    appName: 'Nama:',
    version: 'Versi:',
    fileSize: 'Ukuran file:',
    releaseDate: 'Tanggal rilis:',
    androidReq: 'Android diperlukan:',
    developer: 'Pengembang:',
    price: 'Harga:',
    license: 'Lisensi:',
    march2026: 'Maret 2026',
    free: 'Gratis',
    freeware: 'Freeware',
    modsTitle: 'MOD WhatsApp Lainnya Tersedia',
    modsIntro: 'Kami juga menyediakan unduhan untuk modifikasi WhatsApp populer lainnya:',
    featuresTitle: 'Yang Baru di GBWhatsApp v18.80',
    installTitle: 'Cara Mengunduh dan Menginstal GBWhatsApp',
    requirementsTitle: 'Persyaratan Sistem',
    faqTitle: 'Pertanyaan yang Sering Diajukan',
    faq1Q: 'Apakah GBWhatsApp aman untuk diunduh?',
    faq1A: 'Ya, GBWhatsApp aman ketika diunduh dari sumber tepercaya. Unduhan kami terverifikasi dan mencakup perlindungan anti-ban.',
    faq2Q: 'Apakah saya akan kehilangan chat jika beralih ke GBWhatsApp?',
    faq2A: 'Tidak, Anda dapat mencadangkan chat di WhatsApp dan memulihkannya di GBWhatsApp saat pengaturan.',
    faq3Q: 'Bisakah saya menggunakan GBWhatsApp dengan akun WhatsApp saya saat ini?',
    faq3A: 'Tidak, Anda memerlukan nomor telepon yang berbeda untuk GBWhatsApp. Anda dapat menggunakan kedua aplikasi secara bersamaan.',
  },
};
